<template>
    <div class="container">

        <div class="header f-s-b">
            <div class="header-item header-item-active theme-color-font">预约讲解</div>
            <div class="header-item item-line " ></div>
            <div class="header-item">提交</div>
        </div>

        <div class="body">
            <div class="body-container f-s-b">
                <van-image 
                    class="body-image"
                    lazy-load
                    fit="contain"
                    :src="image"
                />
                <div class="body-title">预约成功</div>
                <div class="body-desc">请提前15分钟达到现场等待讲解员</div>
                <div class="btn-box f-s-b">
                    <div class="f-c back-home" v-touch:tap="routerPage('ticketing')">返回首页</div>
                    <div class="f-c look-qr" v-touch:tap="routerPage('personalCenter')">查看我的预约</div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                image: require('@image/home/4567.png'),
            }
        },
        methods: {
            routerPage(name){
                return ()=> this.$router.push({ name })
            },
        },
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";

    .container{
        .header{
            position: relative;
            padding: 0 35px 0 65px;
            box-sizing: border-box;
            background-color: #ffffff;
            height: 56px;
            color: #9C9C9C;
            .header-item{
                white-space: nowrap;
                width: auto;
                position: relative;
                text-align: center;
            }
            .item-line{
                width: 30%;
                border-bottom: 1px dotted #9C9C9C;
            }
            .header-item-active{
                margin-left: -25px;
                &::before{
                    background-color: #4282FF;
                    content: '';
                    border-radius: 2px;
                    height: 5px;
                    width: 65px;
                    position: absolute;
                    bottom: -10px;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
        }
        .body{
            position: relative;
            box-sizing: border-box;
            height: ~"calc(100% - 56px)";
            min-height: 506px;
            padding: 20px 7px;
            .body-container{
                justify-content: flex-start;
                box-sizing: border-box;
                flex-direction: column;
                padding: 35px 30px 0;
                width: 100%;
                height:100%;
                background:rgba(255,255,255,1);
                box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                border-radius:5px;
                .body-image{
                    width: 200px;
                }
                .body-title{
                    margin-top: 18px;
                    font-size:18px;
                    font-weight:600;
                    color:rgba(54,92,132,1);
                }
                .body-desc{
                    margin-top: 6px;
                    font-size:16px;
                    font-weight:400;
                    color:rgba(71,75,78,1);
                }
                .btn-box{
                    margin-top: 84px;
                    width: 100%;
                    .back-home{
                        color: rgba(105,170,254,1);
                        width:135px;
                        height:37px;
                        border-radius:5px;
                        border:1px solid rgba(105,170,254,1);
                    }
                    .look-qr{
                        color: #ffffff;
                        width:135px;
                        height:37px;
                        background:rgba(92,162,253,1);
                        border-radius:5px;
                    }
                }
            }
        }
    }
</style>